exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ytT8{position:relative;padding:10px 10px 0;margin:40px 0 23px;background-color:#fff}._2xpjr{font-size:17px;font-weight:700;padding-top:0;margin:0 0 9px}._2pbGq{margin-bottom:5px;overflow:hidden;border-bottom:1px solid #eee}._1TaR7{position:absolute;right:5px;top:5px;z-index:1}._2pbGq img{width:100%}._2kd8k{position:absolute;bottom:0;top:0;left:0;right:0;background-color:rgba(0,0,0,.3)}._2pbGq:hover ._2kd8k{display:none}._2Ezrb{position:relative;overflow:hidden;margin:-1px -10px 0}._3JBhn,.ANbuH{border-radius:0;position:relative;display:block;width:50%;font-size:13px;margin:0;padding:14px 20px;background-color:#fff;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0}.ANbuH{float:left;padding-right:10px;border-right:1px solid #f1f1f1}._3JBhn{float:right;padding-left:10px}._2Ezrb button:hover{color:#e73232}._2DKQe{font-size:20px;height:22px;position:absolute;top:0;bottom:0;margin:auto}.ANbuH ._2DKQe{left:15px}._3JBhn ._2DKQe{right:15px}.FsBWy{background-position:50%;background-size:cover}._3lZiG{position:absolute;bottom:0;padding:5px 10px 15px;left:0;right:0;color:#fff}._2pbGq{position:relative;cursor:pointer;display:block}._2pbGq ._2xpjr{font-weight:600;font-size:16px;line-height:19px;margin-bottom:5px}._381re{font-size:14px}._381re span{line-height:14px;margin-right:10px}._381re svg{margin-right:5px}._381re svg path{fill:#fff}._1qjk5{margin-top:10px}._1VINi{margin-top:5px;display:inline-block;font-size:14px;background-color:#ffd906;padding:2px 5px;border-radius:1px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2ytT8",
	"title": "_2xpjr",
	"car": "_2pbGq",
	"label": "_1TaR7",
	"subInfo": "_2kd8k",
	"btns": "_2Ezrb",
	"btnPrev": "ANbuH",
	"btnNext": "_3JBhn",
	"btnIcon": "_2DKQe",
	"img": "FsBWy",
	"text": "_3lZiG",
	"info": "_381re",
	"priceWrapper": "_1qjk5",
	"contractPrice": "_1VINi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SpecialAdvertCars/SpecialAdvertCars.css
// module id = 3279
// module chunks = 32